import { EnvironmentUrls } from 'Roblox'; 
import notificationStreamModule from "../notificationStreamModule";

function notificationStreamService(httpService, $log, urlService) {
    "ngInject";

    const { notificationApi, chatApi, friendsApi } = EnvironmentUrls;
    var initializeUrl = notificationApi + "/v2/stream-notifications/metadata";
    var acceptFriendRequestUrl = "/api/friends/acceptfriendrequest";
    var ignoreFriendRequestUrl = "/api/friends/declinefriendrequest";

    return {
        endpoints: {
            "acceptFriendRequest": { url: urlService.getAbsoluteUrl(acceptFriendRequestUrl), retryable: false },
            "ignoreFriendRequest": { url: urlService.getAbsoluteUrl(ignoreFriendRequestUrl), retryable: false },
            "initializeData": { url: initializeUrl, retryable: true },
            "unreadCount": { url: notificationApi + "/v2/stream-notifications/unread-count", retryable: true, withCredentials: true },
            "getRecent": { url: notificationApi + "/v2/stream-notifications/get-recent", retryable: true, withCredentials: true },
            "clearUnread": { url: notificationApi + "/v2/stream-notifications/clear-unread", retryable: false, withCredentials: true },
            "markInteracted": { url: notificationApi + "/v2/stream-notifications/mark-interacted", retryable: false, withCredentials: true },
            "updateNotificationSettings": { url: notificationApi + "/v2/notifications/update-notification-settings", retryable: false, withCredentials: true },
            "getChatPrivacySettings": { url: chatApi + "/v2/chat-settings", retryable: false, withCredentials: true }
        },

        initialize: function () {
            var params = {};
            return httpService.httpGet(this.endpoints["initializeData"], params);
        },


        getChatPrivacySettings: function () {
            var params = {};
            return httpService.httpGet(this.endpoints["getChatPrivacySettings"], params);
        },

        unreadCount: function () {
            var params = {};
            return httpService.httpGet(this.endpoints["unreadCount"], params);
        },

        clearUnread: function () {
            var data = {};
            return httpService.httpPost(this.endpoints["clearUnread"], data);
        },

        getRecentNotifications: function (startIndexOfNotifications, pageSizeOfNotifications) {
            var params = {
                startIndex: startIndexOfNotifications,
                maxRows: pageSizeOfNotifications
            };

            return httpService.httpGet(this.endpoints["getRecent"], params);
        },

        markInteracted: function (eventId) {
            var data = {
                eventId: eventId
            };
            return httpService.httpPost(this.endpoints["markInteracted"], data);
        },

        acceptFriend: function (targetUserId) {
            var data = {
                targetUserID: targetUserId
            };
            return httpService.httpPost(this.endpoints["acceptFriendRequest"], data);
        },

        acceptFriendV2: function (targetUserId) {
            var urlConfig = {
                url: friendsApi + "/v1/users/" + targetUserId + "/accept-friend-request",
                withCredentials: true
            };

            return httpService.httpPost(urlConfig);
        },

        ignoreFriend: function (targetUserId) {
            var data = {
                targetUserID: targetUserId
            };
            return httpService.httpPost(this.endpoints["ignoreFriendRequest"], data);
        },

        ignoreFriendV2: function (targetUserId) {
            var urlConfig = {
                url: friendsApi + "/v1/users/" + targetUserId + "/decline-friend-request",
                withCredentials: true
            };

            return httpService.httpPost(urlConfig);
        },

        updateNotificationSettings: function (notificationSourceType, isEnabled) {
            var data = {
                notificationSourceType: notificationSourceType,
                receiverDestinationType: "NotificationStream",
                isEnabled: isEnabled
            };
            var list = [];
            list.push(data);
            return httpService.httpPost(this.endpoints["updateNotificationSettings"], list);
        }
    }
}

notificationStreamModule.factory("notificationStreamService", notificationStreamService);

export default notificationStreamService;